<div>
    <input type="date" ng-model="startDate" ng-disabled='isDisabled' required="required">
    <input type="date" ng-model="endDate" min="{{startDate}}" ng-disabled='isDisabled'
           required="required">
</div>
